import styled from "styled-components"

const Section = styled.div`
  padding-top: ${({theme}) => theme.spacing.four};
  padding-bottom: ${({theme}) => theme.spacing.four};
`

export default Section
